<template>
  <div class="customer-select">
    <div class="main">
      <div class="search-bar">
        <base-input
          v-model="search"
          :placeholder="$t('general.search')"
          focus
          type="text"
          icon="search"
          @input="searchSupplier"
        />
      </div>

      <div v-if="(suppliers.length > 0) && !loading" class="list">
        <div
          v-for="(supplier, index) in suppliers"
          :key="index"
          class="list-item"
          @click="selectNewSupplier(supplier.id)"
        >
          <span class="avatar" >{{ initGenerator(supplier.name) }}</span>
          <div class="name">
            <label class="title">{{ supplier.name }}</label>
            <label class="sub-title">{{ supplier.contact_name }}</label>
          </div>
        </div>
      </div>
      <div v-if="loading" class="list flex justify-content-center align-items-center">
        <font-awesome-icon icon="spinner" class="fa-spin"/>
      </div>
      <div v-if="suppliers.length === 0" class="no-data-label">
        <label> {{ $t('suppliers.no_suppliers_found') }} </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      search: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters('customer', [
      'customers'
    ]),
    ...mapGetters('supplier', [
      'suppliers'
    ])
  },
  created () {
    this.fetchInitialSuppliers()
  },
  methods: {
    ...mapActions('supplier', [
      'fetchSuppliers'
    ]),
    ...mapActions('po', {
      setPurchaseOrderSupplier: 'selectSupplier'
    }),
    async fetchInitialSuppliers () {
      await this.fetchSuppliers({
        filter: {},
        orderByField: '',
        orderBy: ''
      })
    },
    async searchSupplier () {
      let data = {
        display_name: this.search,
        email: '',
        phone: '',
        orderByField: '',
        orderBy: '',
        page: 1
      }

      this.loading = true

      await this.fetchSuppliers(data)

      this.loading = false
    },
    
    initGenerator (name) {
      if (name) {
        let nameSplit = name.split(' ')
        let initials = nameSplit[0].charAt(0).toUpperCase()
        return initials
      }
    },
    selectNewSupplier (id) {
      if (this.type === 'purchaseOrder') {
        this.setPurchaseOrderSupplier(id)
      }
    }
  }
}
</script>
